<template>
    <BaseSection width="page-narrow">
        <BigLinks :links="biglinks" />
    </BaseSection>
</template>

<script setup>
defineProps({
    biglinks: {
        type: Array,
        default: () => []
    }
});
</script>
